import { gql } from '@apollo/client';

export const TERM_ITEMS = gql`
	query TermItems($termType: String, $fulltext: String, $take: Int = 999) {
		termItems(termType: $termType, fulltext: $fulltext, take: $take) {
			data {
				id
				termId
				name
				value
				value2
				value3
				data
			}
		}
	}
`;
